/* eslint-disable no-unused-expressions */

import { MARKETING_TAGS } from '../constants';
import urlUtils from './urlutils';
import hashSHA256 from './cryptoUtils';

function checkIsBrokerInvited(marketingTagsParsed) {
  if (!marketingTagsParsed) return false;

  if (
    marketingTagsParsed.referral_code ||
    (marketingTagsParsed.inviterRole && marketingTagsParsed.inviterRole.toLowerCase() === 'broker')
  ) {
    return true;
  }
}

export const getMarketingTagsMapped = () => {
  const marketingTags = window.sessionStorage.getItem(MARKETING_TAGS);
  if (marketingTags) {
    const marketingTagsParsed = JSON.parse(marketingTags);

    Object.keys(marketingTagsParsed).forEach((k) => {
      if (Array.isArray(marketingTagsParsed[k])) {
        marketingTagsParsed[k] = marketingTagsParsed[k][0];
      }
    });

    if (Object.keys(marketingTagsParsed).length > 0) {
      //only shift connect uses referral code as per acceptance criteria ACAT-3446
      const isBrokerInvited = checkIsBrokerInvited(marketingTagsParsed);

      // reading from lead_source and account_source below is for backward compatibility 2020 Dec 2, ask product owner before cleanup
      const marketingTags = {
        referrerAccount:
          marketingTagsParsed.referrer_account ||
          marketingTagsParsed.account_source ||
          marketingTagsParsed.lead_source,
        product: marketingTagsParsed.product,
        amount: marketingTagsParsed.amount,
        contactSource: marketingTagsParsed.contact_source,
        term: marketingTagsParsed.term,
        termPeriod: marketingTagsParsed.termPeriod,
        utmCampaign: marketingTagsParsed.utm_campaign,
        utmTerm: marketingTagsParsed.utm_term,
        utmProduct: marketingTagsParsed.utm_product,
        utmMedium: marketingTagsParsed.utm_medium,
        utmContent: marketingTagsParsed.utm_content,
        utmSource: marketingTagsParsed.utm_source,
        accountType: marketingTagsParsed.account_type,
        widgetName: marketingTagsParsed.widget_name,
        referralCode: marketingTagsParsed.referral_code,
        initiatedBy: marketingTagsParsed.initiatedBy,
        senderGcContactId: marketingTagsParsed.sender_gc_contact_id,
        inviterRole: marketingTagsParsed.inviterRole,
        gclId: marketingTagsParsed.gclid,
        isBrokerInvited,
      };

      return JSON.parse(JSON.stringify(marketingTags));
    }
  }
};

export function digitalRegistrationLoadedEvent() {
  try {
    const marketingTagsMapped = getMarketingTagsMapped() ?? {};
    window?.dataLayer?.push({
      ...marketingTagsMapped,
      category: 'Digital Rego Event',
      action: 'Rego loaded',
      label: 'Rego loaded',
      event: 'Rego load success',
    });
  } catch (error) {
    console.debug(error);
  }
}

export function digitalRegistrationStepOneCompleteEvent() {
  try {
    const marketingTagsMapped = getMarketingTagsMapped() ?? {};
    window?.dataLayer?.push({
      ...marketingTagsMapped,
      category: 'Digital Rego Event',
      action: 'Step01 complete',
      label: 'Step01 complete',
      event: 'RegoStep 01 success',
    });
  } catch (error) {
    console.debug(error);
  }
}

export function digitalRegistrationStepTwoCompleteEvent() {
  try {
    const marketingTagsMapped = getMarketingTagsMapped() ?? {};
    window?.dataLayer?.push({
      ...marketingTagsMapped,
      category: 'Digital Rego Event',
      action: 'Step02 complete',
      label: 'Step02 complete',
      event: 'RegoStep 02 success',
    });
  } catch (error) {
    console.debug(error);
  }
}

export function digitalRegistrationStepThreeCompleteEvent() {
  try {
    const marketingTagsMapped = getMarketingTagsMapped() ?? {};
    window?.dataLayer?.push({
      ...marketingTagsMapped,
      category: 'Digital Rego Conversion',
      action: 'Step03 complete',
      label: 'Step03 complete',
      event: 'RegoStep 03 success',
    });
  } catch (error) {
    console.debug(error);
  }
}

export function digitalRegistrationConversion(accountId) {
  try {
    const marketingTagsMapped = getMarketingTagsMapped() ?? {};
    window?.dataLayer?.push({
      accountId,
      ...marketingTagsMapped,
      category: 'Digital Rego Conversion',
      action: 'TagSuccess',
      label: 'rego success',
      event: 'TagSuccess',
    });
  } catch (error) {
    console.debug(error);
  }
}

export async function gtmUserJourneyEvent({
  eventType,
  accountType,
  documentType,
  isError,
  mobileNumber,
  fieldName,
  errorType,
  userId,
}) {
  let userJourneyAccountType;

  if (accountType) {
    userJourneyAccountType = accountType;
  } else {
    userJourneyAccountType = urlUtils.getUserJourneyAccountType();
  }

  const mobileNumberHash = mobileNumber ? await hashSHA256(mobileNumber) : '';

  if (userJourneyAccountType) {
    window?.dataLayer?.push({
      account_type: userJourneyAccountType,
      event: eventType,
      id_type: documentType,
      error_type: isError && errorType,
      mobileNumber: mobileNumberHash,
      field_name: fieldName || '',
      user_id: userId,
    });
  }
}
